import Icon from '../icon';
import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    type, className, percent, _status: status, size,
    isOuterText, isInnerText, strokeWidth,
    children, color
} = self.get();

const classNameObj = {
    'k-progress' : true,
    [`k-${type}`]: type,
    [className]: className,
    [`k-${status}`]: status !== 'normal',
    [`k-${size}`]: size !== 'default',
}

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (type === 'bar' )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, h('div', null, h('div', {
                'style': function() {try {return ({width: percent + '%', backgroundColor: self.getColor(color) })} catch(e) {_e(e)}}.call($this)
            }, function() {try {return (isInnerText )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, [
                    function() {try {return (percent )} catch(e) {_e(e)}}.call($this),
                    ' %\n                '
                ], 'k-inner-text') :
                undefined, 'k-bg'), 'k-content'), 'k-container') :
            undefined,
        function() {try {return (type === 'circle' )} catch(e) {_e(e)}}.call($this) ?
            h('svg', {
                'viewBox': '0 0 120 120'
            }, function() {try {return (do {
            const r = (120 - strokeWidth) / 2;
            const circumference = 2 * Math.PI * r;

            [
                h('circle', {
                'cx': '60',
                'cy': '60',
                'r': function() {try {return (r )} catch(e) {_e(e)}}.call($this),
                'stroke-width': function() {try {return (strokeWidth )} catch(e) {_e(e)}}.call($this)
            }, null, 'k-meter'),
                h('circle', {
                'cx': '60',
                'cy': '60',
                'r': function() {try {return (r )} catch(e) {_e(e)}}.call($this),
                'stroke-dashoffset': function() {try {return (circumference * (1 - percent / 100) )} catch(e) {_e(e)}}.call($this),
                'stroke-dasharray': function() {try {return (circumference )} catch(e) {_e(e)}}.call($this),
                'stroke-width': function() {try {return (strokeWidth )} catch(e) {_e(e)}}.call($this)
            }, null, 'k-value'),
                function() {try {return (status === 'active' )} catch(e) {_e(e)}}.call($this) ?
                h('circle', {
                    'cx': '60',
                    'cy': '60',
                    'r': function() {try {return (r )} catch(e) {_e(e)}}.call($this),
                    'stroke-width': function() {try {return (strokeWidth )} catch(e) {_e(e)}}.call($this),
                    'stroke-dasharray': function() {try {return (circumference )} catch(e) {_e(e)}}.call($this),
                    'stroke-dashoffset': function() {try {return (circumference )} catch(e) {_e(e)}}.call($this)
                }, [
                    h('animate', {
                        'attributeName': 'stroke-dashoffset',
                        'begin': '0s',
                        'dur': '2s',
                        'repeatCount': 'indefinite',
                        'from': function() {try {return (circumference)} catch(e) {_e(e)}}.call($this),
                        'to': function() {try {return (circumference * (1 - percent / 100))} catch(e) {_e(e)}}.call($this)
                    }),
                    h('animate', {
                        'attributeName': 'opacity',
                        'begin': '0s',
                        'dur': '2s',
                        'repeatCount': 'indefinite',
                        'from': '0.2',
                        'to': '0'
                    })
                ], 'k-animate') :
                undefined
            ]
        } )} catch(e) {_e(e)}}.call($this), 'k-canvas') :
            undefined,
        function() {try {return (children )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), 'k-text') :
            function() {try {return (isOuterText )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, function() {try {return (status !== 'success' && status !== 'error' )} catch(e) {_e(e)}}.call($this) ?
                    h('span', null, [
                        function() {try {return (percent )} catch(e) {_e(e)}}.call($this),
                        '%'
                    ]) :
                    function() {try {return (status === 'success' )} catch(e) {_e(e)}}.call($this) ?
                        h('span', null, h(Icon, {
                            'className': 'k-icon-truth',
                            '_context': $this
                        })) :
                        function() {try {return (status === 'error' )} catch(e) {_e(e)}}.call($this) ?
                            h('span', null, h(Icon, {
                                'className': 'k-icon-fault',
                                '_context': $this
                            })) :
                            undefined, 'k-text') :
                undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}